<template lang="pug">
v-list-item-group.pa-0(color="primary", :class="{'two-columns': twoColumns}")
  AttachmentsListItem.mt-4(
  style="max-width:350px; margin-right:16px",
    :attachment="attachment",
    v-for="attachment in attachments",
    :key="attachment.id"
  )
</template>

<script lang="ts">
import { Attachment } from "suus-api"
import { defineComponent, PropType } from "vue"
import AttachmentsListItem from "components/AttachmentListItem.vue"

export default defineComponent({
  name: "AttachmentListItemGroup",
  components: { AttachmentsListItem },
  props: {
    attachments: { type: Array as PropType<Attachment[]>, required: true },
    twoColumns: { type: Boolean, required: false, default: false },
  },
})
</script>

<style>
.two-columns {
  display: flex;
  flex-wrap: wrap;
}

.two-columns > * {
  flex: 1 1 50%;
}
</style>
